@if (status() !== 'bereit') {
  <app-details-historie-status [status]="status()" [fehlerText]="fehlerText()" (retry)="retry.emit()" />
} @else if (eintraege().length) {
  <ul class="verlauf-liste">
    @for (eintrag of eintraege(); track $index) {
      @let unbekannt = istLeer(eintrag.personName);
      @let name = unbekannt ? ('common.unknownUser' | translate) : eintrag.personName;
      <li class="verlauf-liste__zeile">
        <app-avatar [name]="name" [size]="26" [neutral]="unbekannt" [initialen]="unbekannt ? '?' : null" />
        <div class="verlauf-liste__text">
          <div class="verlauf-liste__titel">
            <strong class="verlauf-liste__name">{{ name }}</strong>
            · {{ eintrag.ereignis }}
          </div>
          @if (!istLeer(eintrag.detail)) {
            <div class="verlauf-liste__detail">{{ eintrag.detail }}</div>
          }
        </div>
        <time class="verlauf-liste__zeit" [attr.datetime]="eintrag.zeit">{{ eintrag.zeit | date: zeitMuster }}</time>
      </li>
    }
  </ul>
} @else {
  <p class="verlauf-liste__leer">{{ leerText() || ('common.detailsHistorie.verlauf.leer' | translate) }}</p>
}
